module.exports = __webpack_public_path__ + "img/176-fa96ba.png";